import {unexpectedCase} from 'nutshell-core/reducer-utils';

import {ActionTypes} from './messages-actions';
import type {MessagesAction} from './messages-actions';

export type MessagesState = {
    dismissedMessageIds: string[];
};

const defaultMessagesState = {
    dismissedMessageIds: [],
} as const;

export const reducer = (
    // @ts-expect-error
    state: MessagesState | null | undefined = defaultMessagesState,
    action: MessagesAction
): MessagesState => {
    switch (action.type) {
        case ActionTypes.MESSAGE_DISMISSED:
            return {
                ...state,
                // @ts-expect-error
                dismissedMessageIds: state.dismissedMessageIds.concat([action.payload]),
            };
        case 'persist/REHYDRATE': {
            const persistedState = action.payload;

            if (!persistedState || !persistedState.ui || !persistedState.ui.messages) {
                // @ts-expect-error
                return state;
            }

            return {
                ...state,
                dismissedMessageIds: persistedState.ui.messages.dismissedMessageIds,
            };
        }
        default:
            // @ts-expect-error
            unexpectedCase(action.type);

            // @ts-expect-error
            return state;
    }
};
